<script lang="ts">
	import { get } from 'svelte/store';
	import { page } from '$app/stores';
	import type { ServiceListBlock } from './ServiceListBlockQuery';
	import ServiceIcon from '$lib/icons/ServiceIcon.svelte';
	import ServiceButtons from '@comp/ServiceButtons.svelte';
	import { Asset, Headline } from '@atoms';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import type { ServiceThumbType } from '@queries/GlobalQuery';

	const { data }: { data: ServiceListBlock } = $props();
	const services = get(page).data.globals.allServices;

	let activeService = $state(services[0]);

	function onHover(service: ServiceThumbType) {
		activeService = service;
	}

	createViewController();
</script>

<section use:ViewController>
	<div class="headline {data.layout}" use:EnterOnView>
		<Headline borderBottom={true} text={data.headline} />
	</div>

	<div class="container">
		{#if data.layout === 'with_icon'}
			<div class="img" use:EnterOnView={{ delay: 0.15 }}>
				{#if activeService.thumbAsset}
					<Asset data={activeService.thumbAsset} />
				{:else}
					<ServiceIcon></ServiceIcon>
				{/if}
			</div>
		{:else}
			<div class="inside-headline {data.layout}" use:EnterOnView={{ delay: 0.15 }}>
				<Headline text={data.headline} />
			</div>
		{/if}
		<div class="content {data.layout}">
			<ServiceButtons {onHover} {services}></ServiceButtons>
		</div>
	</div>
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;
	}

	.inside-headline {
		transform: translateY(-5px);
		grid-column: 1 / 4;
		display: none;

		@include md {
			display: block;
		}
	}

	.headline {
		@include layoutBlockGrid(false);
		:global(.container) {
			grid-column: 1 / -1;
		}

		&.without_icon {
			:global(h2) {
				@include md {
					display: none;
				}
			}
		}
	}

	.container {
		@include layoutBlockGrid(false);
		.img {
			display: none;

			@include md {
				display: flex;
				justify-content: center;
				align-items: center;
				grid-column: 1 / span 6;
				background-color: #f1efea;
			}
		}
		.content {
			display: grid;
			grid-template-columns: repeat(1, 1fr);
			grid-column-gap: var(--prop-gap);
			margin-top: -20px;
			grid-column: 1 / -1;

			@include md {
				&.with_icon {
					grid-template-columns: repeat(2, 1fr);
					grid-column: 7 / span 6;
				}
				&.without_icon {
					grid-template-columns: repeat(3, 1fr);
					grid-column: 4 / -1;
				}
			}
		}
	}
</style>
